import { render, staticRenderFns } from "./ConsortiumContracts.vue?vue&type=template&id=4829e32c&scoped=true"
import script from "./ConsortiumContracts.vue?vue&type=script&lang=js"
export * from "./ConsortiumContracts.vue?vue&type=script&lang=js"
import style0 from "./ConsortiumContracts.vue?vue&type=style&index=0&id=4829e32c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4829e32c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4829e32c')) {
      api.createRecord('4829e32c', component.options)
    } else {
      api.reload('4829e32c', component.options)
    }
    module.hot.accept("./ConsortiumContracts.vue?vue&type=template&id=4829e32c&scoped=true", function () {
      api.rerender('4829e32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Consortium/ConsortiumContracts.vue"
export default component.exports